import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bundleType',
  standalone: false, // eslint-disable-line
})
export class BundleTypePipe implements PipeTransform {
  private typeMap = {
    order: 'Ordrer',
    refund: 'Refunderinger',
    incoming_txn_gateway: 'Betaling - Betalingsgateway',
    incoming_txn_sales_channel: 'Betaling - Salgskanal',
    incoming_txn_gift_card: 'Betaling - Gavekort',
    outgoing_txn_gateway: 'Tilbagebetaling - Betalingsgateway',
    outgoing_txn_sales_channel: 'Tilbagebetaling - Salgskanal',
    outgoing_txn_gift_card: 'Tilbagebetaling - Gavekort',
    correction: 'Korrektioner',
    return: 'Return',
    fulfillment: 'Fulfillment',
  };

  transform(value: string): string {
    return this.typeMap[value] ?? value;
  }
}
